module.exports = __webpack_public_path__ + "img/stock4.579f1e32.png";